// extracted by mini-css-extract-plugin
module.exports = {"spinBox":"src-pages-home-__index__spinBox--LPKIx","alert":"src-pages-home-__index__alert--3yEe7"};